import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles }) => {
    const token = useSelector((state) => state.token);
    const user = useSelector((state) => state.user); // Assuming user object with a 'role' field is in Redux state
    const location = useLocation();

    // Check for token first
    if (!token) {
        // Redirect them to the / page if not authenticated
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If allowedRoles is provided, check if the user's role is included
    if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
        // Redirect them to the / page if their role is not allowed for this route
        // Or to a specific 'Unauthorized' page if you have one
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If authenticated and (no specific roles required OR user has allowed role), render the child components
    return <Outlet />;
};

export default ProtectedRoute; 